<template>
  <pagefra>
    <div class="weixin container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            :inline="true"
            v-model="form"
            size="medium"
            class="toolbar-form"
          >
            <el-form-item :label="$l('用户名')">
              <el-input
                v-model="form.username"
                maxlength="30"
                :placeholder="$l('用户名')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              round
              type="success"
              icon="el-icon-plus"
              @click="setting(1)"
              v-if="hasPermission('启用')"
              >{{ $l("启用") }}
            </el-button>
            <el-button
              round
              type="danger"
              icon="el-icon-plus"
              @click="setting(0)"
              v-if="hasPermission('禁用')"
              >{{ $l("禁用") }}
            </el-button>
            <el-button
              round
              type="danger"
              icon="el-icon-delete"
              @click="unbind()"
              v-if="hasPermission('解绑')"
              >{{ $l("解绑") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            v-loading.lock="loading"
            :element-loading-text="$l('加载中')"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="username"
              :label="$l('用户名')"
              min-width="160"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="openid"
              :label="$l('微信用户')"
              min-width="260"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="alarmSwitch"
              :label="$l('报警推送')"
              min-width="160"
              header-align="center"
              align="center"
              :formatter="alarmSwitchFormatter"
            >
            </el-table-column>
            <el-table-column
              property="alarmType"
              :label="$l('报警类型')"
              min-width="160"
              header-align="center"
              align="center"
              :formatter="alarmTypeFormatter"
            >
            </el-table-column>
            <el-table-column
              property="createTime"
              :label="$l('绑定时间')"
              min-width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
    </div>
  </pagefra>
</template>

<script>
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";

export default {
  name: "weixin",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        pageNum: 0,
        pageSize: 0,
        username: "",
      },
      loading: false,
      tableData: null,
      selectedList: [],
    };
  },
  mounted: function () {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_weixin_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    setting(type) {
      let len = this.selectedList.length;
      const typeStr = type == 1 ? "启用" : "禁用";
      if (len == 0) {
        this.message(1, "请选择要" + typeStr + "的数据");
        return;
      }
      this.confirmAlert(() => {
        let openIdList = [];
        for (let i = 0; i < len; i++) {
          openIdList.push(this.selectedList[i].openid);
        }
        // let formData = new FormData();
        // formData.append("alarmSwitch", type);
        // formData.append("openIdList", openIdList);
        this.$http
          .post(this.$apiConfig.set_wx_url, {
            alarmSwitch: type,
            openIdList: openIdList,
          })
          .then((response) => {
            let data = response.data;
            this.message(data.code, data.msg);
            if (data.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.message(-1, typeStr + "失败");
            this.$sentry.captureException(error);
          });
      }, "你确定要" + typeStr + "吗?");
    },
    unbind() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要解绑的数据");
        return;
      }
      this.confirmAlert(() => {
        let openIdList = [];
        for (let i = 0; i < len; i++) {
          openIdList.push(this.selectedList[i].openid);
        }
        let formData = new FormData();
        formData.append("openIdList", openIdList);
        this.$http
          .post(this.$apiConfig.unbind_wx_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let data = response.data;
            this.message(data.code, data.msg);
            if (data.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.message(-1, "解绑失败");
            this.$sentry.captureException(error);
          });
      }, "你确定要解绑吗?");
    },
    alarmSwitchFormatter(row) {
      if (row.alarmSwitch == 0) {
        return "禁用";
      }
      return "启用";
    },
    alarmTypeFormatter(row) {
      if (row.alarmType == 0) {
        return "全部";
      } else if (row.alarmType == 1) {
        return "仅派工";
      } else {
        return "仅困人";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-form {
  .el-input {
    width: 400px;
  }
  .el-textarea {
    width: 400px;
  }
  .el-select {
    width: 400px;
  }
  .el-cascader {
    width: 400px;
  }
}
.select-tree {
  width: 370px;
  height: 200px;
  overflow-y: scroll;
}
/* 菜单滚动条 */
.select-tree::-webkit-scrollbar {
  z-index: 11;
  width: 6px;
}
.select-tree::-webkit-scrollbar-track,
.select-tree::-webkit-scrollbar-corner {
  background: #fff;
}
.select-tree::-webkit-scrollbar-thumb {
  border-radius: 5px;
  width: 6px;
  background: #b4bccc;
}
.select-tree::-webkit-scrollbar-track-piece {
  background: #fff;
  width: 6px;
}
</style>
